// extracted by mini-css-extract-plugin
export default {"card":"lZ-z"};